export default __webpack_public_path__ + "static/media/1.050d29e4.jpg";